import React, {memo} from 'react';

import './index.scss';

interface BusyIndicatorProps {
    message?: string;
}

export const BusyIndicator = memo(function BusyIndicator({message}: BusyIndicatorProps) {
    return (
        <div className='busy-indicator'>
            <div className='loader'>
            </div>
            {message && (
                <div className='message'>
                    {message}
                </div>
            )}
        </div>
    );
});
